'use client';
import React from 'react';
import Link from 'next/link';
import { Flag, ChevronRight } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function CtaStrip() {
  const { user } = useAuth();

  return (
    <section className="py-20 px-4 lg:px-8 xl:px-10 max-w-screen-2xl mx-auto">
      <div className="relative rounded-2xl overflow-hidden bg-card border border-primary/20 card-glow-red">
        <div className="absolute inset-0 racing-stripe opacity-40 pointer-events-none" />
        <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-primary to-accent" />

        <div className="relative z-10 px-8 md:px-12 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Flag size={20} className="text-primary" />
              <span className="text-xs font-bold uppercase tracking-widest text-primary">
                Join the Grid
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-2">SPEEDPASS YOUR RACE NOW!

            </h2>
            <p className="text-muted-foreground text-sm max-w-lg">
              Beginner-friendly and women welcome. Register for the next round and get your car number assigned before slots fill up.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            {!user &&
            <Link
              href="/register"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-bold uppercase tracking-wide rounded-md btn-primary">

                Create Account
                <ChevronRight size={16} />
              </Link>
            }
            <Link
              href="/events"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-bold uppercase tracking-wide rounded-md btn-secondary">

              Browse Events
            </Link>
          </div>
        </div>
      </div>
    </section>);

}